/**
 * Created by toor on 17-10-9.
 */

export default function dimAcNoFilter(input) {
	if (input !== undefined)
		return input.substring(0, 4) + "****" + input.substring(input.length - 4);
}



// WEBPACK FOOTER //
// ./src/modules/filter/dimAcNoFilter.js